import gql from 'graphql-tag';
import { apollo } from 'src/features';

const query = gql`
query RequestTypes($onlyActive: Boolean) {
  allRequestTypes(onlyActive: $onlyActive) {
    id
    name
    description
    defaultType
    active
    system
    teams {
      id
      name
    }
    allTeamsOn
  }
}`;

function parseRequestType(item) {
  return {
    id: item.id,
    title: item.name,
    desc: item.description,
    defaultType: item.defaultType,
    active: item.active,
    system: item.system,
    teams: item.teams,
    allTeamsOn: item.allTeamsOn,
  };
}

function getAllRequestTypes(payload = { onlyActive: false }) {
  const { onlyActive } = payload;
  return apollo.client.query({
    query,
    variables: { onlyActive },
    fetchPolicy: 'network-only',
  }).then((res) => res.data.allRequestTypes.map((item) => parseRequestType(item)));
}

export default getAllRequestTypes;
